// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ImageDetailModal_componentStyle__6clvW","imageContainer":"ImageDetailModal_imageContainer__9RcVp"};